import { isValid } from 'date-fns'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const validator = require('email-validator')

export const validationRules = {
  required: v => !!v || 'Fältet är obligatoriskt!',
  dateTime: v => isValid(new Date(v)) || 'Måste vara ett giligt datum och tid',
  email: v => validator.validate(v) || 'Måste vara en giltig Epost',
  phone: v => {
    if (!v || !v.length) return true
    const phonenumber = parsePhoneNumberFromString(v, 'SE')
    return (
      (phonenumber && phonenumber.isValid()) ||
      'Måste vara ett giltigt telefonnummer'
    )
  },
}
